
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ResourceCardProps {
  title: React.ReactNode;
  description: React.ReactNode;
  buttonText: React.ReactNode;
  onClick?: () => void;
  href?: string;
}

const ResourceCard = ({ 
  title, 
  description, 
  buttonText, 
  onClick, 
  href 
}: ResourceCardProps) => (
  <Card className="h-full flex flex-col">
    <CardHeader>
      <CardTitle>{title}</CardTitle>
    </CardHeader>
    <CardContent className="flex-1">
      <p className="text-muted-foreground">{description}</p>
    </CardContent>
    <CardFooter>
      <Button 
        variant="outline" 
        className="w-full"
        onClick={onClick}
        {...(href ? { as: 'a', href } : {})}
      >
        {buttonText}
      </Button>
    </CardFooter>
  </Card>
);

export default ResourceCard;
